import React, { useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'umi';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty, last } from 'lodash-es';
import { parseAgentThink } from '@/pages/aigc/pages/Agent/ChatPage/utils';
import { useRequestController } from '@/pages/aigc/pages/Agent/Home/hooks/useRequestController.ts';
import IWikiPrompt from '@/pages/aigc/assets/svg/iwiki-prompt.svg';
import './index.scss';
const MayAsk = (props: any) => {
  const {
    question,
    isLastQA,
    streamingState,
    scrollToBottom,
    answer,
    AnswerLoading,
    sendIWikiMessage,
  } = props;
  const location: any = useLocation();
  const {
    query: { sessionId: routeSessionId, snapshotId: snapshotId },
  } = location || {};
  const firstKey = useRef(false);
  const dataSource = useRef({});
  const { rephrase = '', plan = '' } = useMemo(() => {
    const defaultObj = dataSource.current;
    // 如果已经拿到了数据, 就不需要在计算了
    if (firstKey.current) return defaultObj;
    if (last(answer)?.type === 'error' && last(answer)?.value === 'stop') {
      firstKey.current = true;
      return defaultObj;
    }
    const res = parseAgentThink(answer);
    if (res.rephrase) {
      dataSource.current = res;
      firstKey.current = true;
      return res;
    }
    return { rephrase: '', plan: '' };
  }, [answer]);

  const { data, loading, mutate } = useRequestController({
    method: 'POST',
    url: streamingState
      ? `/api/agent_guessnext`
      : `/api/agent/latest_guessnext`,
    refreshDeps: useMemo(
      () => ({
        userInput: question,
        nNum: 3,
        trace_id: uuidv4(),
        rephrase,
        plan: plan === 'plan_json' ? '' : plan,
        sessionid: routeSessionId, // 新加 2025-06-12
      }),
      [question, rephrase, plan, routeSessionId],
    ),
    cacheKey: null,
    ready:
      (isLastQA && !isEmpty(answer) && firstKey.current) ||
      (!streamingState && isLastQA),
    httpCfg: {
      rawData: true,
      ignoreCode: true,
    },
    onFinally: () => {
      firstKey.current = false;
      dataSource.current = {};
      !streamingState && !snapshotId && scrollToBottom?.();
    },
  });

  // 对话变化，直接重置
  useEffect(() => {
    mutate({});
  }, [question]);

  // 这个请求还在加载中，但是我们流式数据还没中断。直接不显示loading
  if (
    (loading && !streamingState) ||
    (loading && streamingState === 'complete')
  ) {
    return <AnswerLoading />;
  }
  // 最后一个QA，或者流式数据还在加载中，直接返回null，加载完成直接出现数据
  if (
    !isLastQA ||
    isEmpty(data?.result?.queries) ||
    (streamingState && ['progressing', 'pending'].includes(streamingState))
  ) {
    return null;
  }
  return (
    <div className="dba-may-ask-iwiki">
      <div className="dba-ask-title-iwiki">
        <span>你可能还想问:</span>
      </div>
      {data?.result?.queries?.map((item: any, index: number) => (
        <div
          key={index}
          className="dba-ask-single-iwiki"
          onClick={() => {
            sendIWikiMessage({ type: 'sendSession', payload: { query: item } });
          }}
        >
          <img src={IWikiPrompt} alt="" />
          <span className="dba-ask-text-iwiki">{item}</span>
        </div>
      ))}
    </div>
  );
};

export default MayAsk;
